import request from "root/js/request";

export const getWBDynamicSellers = async ({
  brand_ids,
  seller_ids,
  category_ids,
  collection_id,
  product_ids,
  wb_search,
  search,
  wb_catalog_url,
  city,
  date_from,
  date_to,
  period,
  limit,
  offset,
  ordering,
  extra_fields = "id",
  ...rest
}) => {
  const response = await request({
    url: `/wb_dynamic/sellers/`,
    method: "get",
    params: {
      brand_ids,
      seller_ids,
      category_ids,
      collection_id,
      product_ids,
      wb_search,
      search,
      wb_catalog_url,
      city,
      date_from,
      date_to,
      period,
      limit,
      offset,
      ordering,
      extra_fields,
      ...rest,
    },
  });
  return response.data;
};
